/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateUser = /* GraphQL */ `subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
  onCreateUser(filter: $filter) {
    id
    username
    email
    firstName
    lastName
    displayName
    profilePictureUrl
    role
    profileCompleted
    playerConstructs {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSubscriptionVariables,
  APITypes.OnCreateUserSubscription
>;
export const onUpdateUser = /* GraphQL */ `subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
  onUpdateUser(filter: $filter) {
    id
    username
    email
    firstName
    lastName
    displayName
    profilePictureUrl
    role
    profileCompleted
    playerConstructs {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSubscriptionVariables,
  APITypes.OnUpdateUserSubscription
>;
export const onDeleteUser = /* GraphQL */ `subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
  onDeleteUser(filter: $filter) {
    id
    username
    email
    firstName
    lastName
    displayName
    profilePictureUrl
    role
    profileCompleted
    playerConstructs {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserSubscriptionVariables,
  APITypes.OnDeleteUserSubscription
>;
export const onCreatePlayerConstruct = /* GraphQL */ `subscription OnCreatePlayerConstruct(
  $filter: ModelSubscriptionPlayerConstructFilterInput
) {
  onCreatePlayerConstruct(filter: $filter) {
    id
    name
    normalizedName
    totalEvents
    totalPoints
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    leagueStats {
      nextToken
      __typename
    }
    eventResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePlayerConstructSubscriptionVariables,
  APITypes.OnCreatePlayerConstructSubscription
>;
export const onUpdatePlayerConstruct = /* GraphQL */ `subscription OnUpdatePlayerConstruct(
  $filter: ModelSubscriptionPlayerConstructFilterInput
) {
  onUpdatePlayerConstruct(filter: $filter) {
    id
    name
    normalizedName
    totalEvents
    totalPoints
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    leagueStats {
      nextToken
      __typename
    }
    eventResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePlayerConstructSubscriptionVariables,
  APITypes.OnUpdatePlayerConstructSubscription
>;
export const onDeletePlayerConstruct = /* GraphQL */ `subscription OnDeletePlayerConstruct(
  $filter: ModelSubscriptionPlayerConstructFilterInput
) {
  onDeletePlayerConstruct(filter: $filter) {
    id
    name
    normalizedName
    totalEvents
    totalPoints
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    leagueStats {
      nextToken
      __typename
    }
    eventResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePlayerConstructSubscriptionVariables,
  APITypes.OnDeletePlayerConstructSubscription
>;
export const onCreateLeaguePlayerStats = /* GraphQL */ `subscription OnCreateLeaguePlayerStats(
  $filter: ModelSubscriptionLeaguePlayerStatsFilterInput
) {
  onCreateLeaguePlayerStats(filter: $filter) {
    id
    leagueId
    league {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    totalPoints
    totalEvents
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    averageFinishPercentile
    currentRank
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLeaguePlayerStatsSubscriptionVariables,
  APITypes.OnCreateLeaguePlayerStatsSubscription
>;
export const onUpdateLeaguePlayerStats = /* GraphQL */ `subscription OnUpdateLeaguePlayerStats(
  $filter: ModelSubscriptionLeaguePlayerStatsFilterInput
) {
  onUpdateLeaguePlayerStats(filter: $filter) {
    id
    leagueId
    league {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    totalPoints
    totalEvents
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    averageFinishPercentile
    currentRank
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLeaguePlayerStatsSubscriptionVariables,
  APITypes.OnUpdateLeaguePlayerStatsSubscription
>;
export const onDeleteLeaguePlayerStats = /* GraphQL */ `subscription OnDeleteLeaguePlayerStats(
  $filter: ModelSubscriptionLeaguePlayerStatsFilterInput
) {
  onDeleteLeaguePlayerStats(filter: $filter) {
    id
    leagueId
    league {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    totalPoints
    totalEvents
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    averageFinishPercentile
    currentRank
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLeaguePlayerStatsSubscriptionVariables,
  APITypes.OnDeleteLeaguePlayerStatsSubscription
>;
export const onCreateLeaguePointAdjustment = /* GraphQL */ `subscription OnCreateLeaguePointAdjustment(
  $filter: ModelSubscriptionLeaguePointAdjustmentFilterInput
) {
  onCreateLeaguePointAdjustment(filter: $filter) {
    id
    leagueId
    userId
    playerConstructId
    playerName
    points
    reason
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLeaguePointAdjustmentSubscriptionVariables,
  APITypes.OnCreateLeaguePointAdjustmentSubscription
>;
export const onUpdateLeaguePointAdjustment = /* GraphQL */ `subscription OnUpdateLeaguePointAdjustment(
  $filter: ModelSubscriptionLeaguePointAdjustmentFilterInput
) {
  onUpdateLeaguePointAdjustment(filter: $filter) {
    id
    leagueId
    userId
    playerConstructId
    playerName
    points
    reason
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLeaguePointAdjustmentSubscriptionVariables,
  APITypes.OnUpdateLeaguePointAdjustmentSubscription
>;
export const onDeleteLeaguePointAdjustment = /* GraphQL */ `subscription OnDeleteLeaguePointAdjustment(
  $filter: ModelSubscriptionLeaguePointAdjustmentFilterInput
) {
  onDeleteLeaguePointAdjustment(filter: $filter) {
    id
    leagueId
    userId
    playerConstructId
    playerName
    points
    reason
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLeaguePointAdjustmentSubscriptionVariables,
  APITypes.OnDeleteLeaguePointAdjustmentSubscription
>;
export const onCreateEventPlayerResult = /* GraphQL */ `subscription OnCreateEventPlayerResult(
  $filter: ModelSubscriptionEventPlayerResultFilterInput
) {
  onCreateEventPlayerResult(filter: $filter) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    points
    omw
    gw
    ogw
    wins
    losses
    draws
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEventPlayerResultSubscriptionVariables,
  APITypes.OnCreateEventPlayerResultSubscription
>;
export const onUpdateEventPlayerResult = /* GraphQL */ `subscription OnUpdateEventPlayerResult(
  $filter: ModelSubscriptionEventPlayerResultFilterInput
) {
  onUpdateEventPlayerResult(filter: $filter) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    points
    omw
    gw
    ogw
    wins
    losses
    draws
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEventPlayerResultSubscriptionVariables,
  APITypes.OnUpdateEventPlayerResultSubscription
>;
export const onDeleteEventPlayerResult = /* GraphQL */ `subscription OnDeleteEventPlayerResult(
  $filter: ModelSubscriptionEventPlayerResultFilterInput
) {
  onDeleteEventPlayerResult(filter: $filter) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    points
    omw
    gw
    ogw
    wins
    losses
    draws
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEventPlayerResultSubscriptionVariables,
  APITypes.OnDeleteEventPlayerResultSubscription
>;
export const onCreateLeague = /* GraphQL */ `subscription OnCreateLeague($filter: ModelSubscriptionLeagueFilterInput) {
  onCreateLeague(filter: $filter) {
    id
    name
    description
    game
    format
    participationPoints
    winPoints
    drawPoints
    lossPoints
    top8FirstPoints
    top8SecondPoints
    top8ThirdFourthPoints
    top8FifthEighthPoints
    commanderFirstPoints
    commanderSecondPoints
    commanderThirdPoints
    commanderFourthPoints
    premiumMultiplier
    startDate
    endDate
    isActive
    maxParticipants
    playerStats {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLeagueSubscriptionVariables,
  APITypes.OnCreateLeagueSubscription
>;
export const onUpdateLeague = /* GraphQL */ `subscription OnUpdateLeague($filter: ModelSubscriptionLeagueFilterInput) {
  onUpdateLeague(filter: $filter) {
    id
    name
    description
    game
    format
    participationPoints
    winPoints
    drawPoints
    lossPoints
    top8FirstPoints
    top8SecondPoints
    top8ThirdFourthPoints
    top8FifthEighthPoints
    commanderFirstPoints
    commanderSecondPoints
    commanderThirdPoints
    commanderFourthPoints
    premiumMultiplier
    startDate
    endDate
    isActive
    maxParticipants
    playerStats {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLeagueSubscriptionVariables,
  APITypes.OnUpdateLeagueSubscription
>;
export const onDeleteLeague = /* GraphQL */ `subscription OnDeleteLeague($filter: ModelSubscriptionLeagueFilterInput) {
  onDeleteLeague(filter: $filter) {
    id
    name
    description
    game
    format
    participationPoints
    winPoints
    drawPoints
    lossPoints
    top8FirstPoints
    top8SecondPoints
    top8ThirdFourthPoints
    top8FifthEighthPoints
    commanderFirstPoints
    commanderSecondPoints
    commanderThirdPoints
    commanderFourthPoints
    premiumMultiplier
    startDate
    endDate
    isActive
    maxParticipants
    playerStats {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLeagueSubscriptionVariables,
  APITypes.OnDeleteLeagueSubscription
>;
export const onCreateEvent = /* GraphQL */ `subscription OnCreateEvent($filter: ModelSubscriptionEventFilterInput) {
  onCreateEvent(filter: $filter) {
    id
    name
    description
    leagueId
    date
    location
    format
    maxRounds
    fieldSize
    isCompleted
    isPremium
    hasTopCut
    playerResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEventSubscriptionVariables,
  APITypes.OnCreateEventSubscription
>;
export const onUpdateEvent = /* GraphQL */ `subscription OnUpdateEvent($filter: ModelSubscriptionEventFilterInput) {
  onUpdateEvent(filter: $filter) {
    id
    name
    description
    leagueId
    date
    location
    format
    maxRounds
    fieldSize
    isCompleted
    isPremium
    hasTopCut
    playerResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEventSubscriptionVariables,
  APITypes.OnUpdateEventSubscription
>;
export const onDeleteEvent = /* GraphQL */ `subscription OnDeleteEvent($filter: ModelSubscriptionEventFilterInput) {
  onDeleteEvent(filter: $filter) {
    id
    name
    description
    leagueId
    date
    location
    format
    maxRounds
    fieldSize
    isCompleted
    isPremium
    hasTopCut
    playerResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEventSubscriptionVariables,
  APITypes.OnDeleteEventSubscription
>;
export const onCreateEventParticipant = /* GraphQL */ `subscription OnCreateEventParticipant(
  $filter: ModelSubscriptionEventParticipantFilterInput
) {
  onCreateEventParticipant(filter: $filter) {
    id
    eventId
    userId
    playerConstructId
    commanderCategory
    registrationDate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEventParticipantSubscriptionVariables,
  APITypes.OnCreateEventParticipantSubscription
>;
export const onUpdateEventParticipant = /* GraphQL */ `subscription OnUpdateEventParticipant(
  $filter: ModelSubscriptionEventParticipantFilterInput
) {
  onUpdateEventParticipant(filter: $filter) {
    id
    eventId
    userId
    playerConstructId
    commanderCategory
    registrationDate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEventParticipantSubscriptionVariables,
  APITypes.OnUpdateEventParticipantSubscription
>;
export const onDeleteEventParticipant = /* GraphQL */ `subscription OnDeleteEventParticipant(
  $filter: ModelSubscriptionEventParticipantFilterInput
) {
  onDeleteEventParticipant(filter: $filter) {
    id
    eventId
    userId
    playerConstructId
    commanderCategory
    registrationDate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEventParticipantSubscriptionVariables,
  APITypes.OnDeleteEventParticipantSubscription
>;
export const onCreateEventStanding = /* GraphQL */ `subscription OnCreateEventStanding(
  $filter: ModelSubscriptionEventStandingFilterInput
) {
  onCreateEventStanding(filter: $filter) {
    id
    eventId
    userId
    rank
    points
    omw
    gw
    ogw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEventStandingSubscriptionVariables,
  APITypes.OnCreateEventStandingSubscription
>;
export const onUpdateEventStanding = /* GraphQL */ `subscription OnUpdateEventStanding(
  $filter: ModelSubscriptionEventStandingFilterInput
) {
  onUpdateEventStanding(filter: $filter) {
    id
    eventId
    userId
    rank
    points
    omw
    gw
    ogw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEventStandingSubscriptionVariables,
  APITypes.OnUpdateEventStandingSubscription
>;
export const onDeleteEventStanding = /* GraphQL */ `subscription OnDeleteEventStanding(
  $filter: ModelSubscriptionEventStandingFilterInput
) {
  onDeleteEventStanding(filter: $filter) {
    id
    eventId
    userId
    rank
    points
    omw
    gw
    ogw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEventStandingSubscriptionVariables,
  APITypes.OnDeleteEventStandingSubscription
>;
export const onCreateMatch = /* GraphQL */ `subscription OnCreateMatch($filter: ModelSubscriptionMatchFilterInput) {
  onCreateMatch(filter: $filter) {
    id
    eventId
    player1Id
    player2Id
    round
    player1Result
    player2Result
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMatchSubscriptionVariables,
  APITypes.OnCreateMatchSubscription
>;
export const onUpdateMatch = /* GraphQL */ `subscription OnUpdateMatch($filter: ModelSubscriptionMatchFilterInput) {
  onUpdateMatch(filter: $filter) {
    id
    eventId
    player1Id
    player2Id
    round
    player1Result
    player2Result
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMatchSubscriptionVariables,
  APITypes.OnUpdateMatchSubscription
>;
export const onDeleteMatch = /* GraphQL */ `subscription OnDeleteMatch($filter: ModelSubscriptionMatchFilterInput) {
  onDeleteMatch(filter: $filter) {
    id
    eventId
    player1Id
    player2Id
    round
    player1Result
    player2Result
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMatchSubscriptionVariables,
  APITypes.OnDeleteMatchSubscription
>;
export const onCreateCommanderRound = /* GraphQL */ `subscription OnCreateCommanderRound(
  $filter: ModelSubscriptionCommanderRoundFilterInput
) {
  onCreateCommanderRound(filter: $filter) {
    id
    eventId
    roundNumber
    status
    publishedAt
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCommanderRoundSubscriptionVariables,
  APITypes.OnCreateCommanderRoundSubscription
>;
export const onUpdateCommanderRound = /* GraphQL */ `subscription OnUpdateCommanderRound(
  $filter: ModelSubscriptionCommanderRoundFilterInput
) {
  onUpdateCommanderRound(filter: $filter) {
    id
    eventId
    roundNumber
    status
    publishedAt
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCommanderRoundSubscriptionVariables,
  APITypes.OnUpdateCommanderRoundSubscription
>;
export const onDeleteCommanderRound = /* GraphQL */ `subscription OnDeleteCommanderRound(
  $filter: ModelSubscriptionCommanderRoundFilterInput
) {
  onDeleteCommanderRound(filter: $filter) {
    id
    eventId
    roundNumber
    status
    publishedAt
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCommanderRoundSubscriptionVariables,
  APITypes.OnDeleteCommanderRoundSubscription
>;
export const onCreateCommanderPod = /* GraphQL */ `subscription OnCreateCommanderPod(
  $filter: ModelSubscriptionCommanderPodFilterInput
) {
  onCreateCommanderPod(filter: $filter) {
    id
    eventId
    roundId
    roundNumber
    podNumber
    category
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCommanderPodSubscriptionVariables,
  APITypes.OnCreateCommanderPodSubscription
>;
export const onUpdateCommanderPod = /* GraphQL */ `subscription OnUpdateCommanderPod(
  $filter: ModelSubscriptionCommanderPodFilterInput
) {
  onUpdateCommanderPod(filter: $filter) {
    id
    eventId
    roundId
    roundNumber
    podNumber
    category
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCommanderPodSubscriptionVariables,
  APITypes.OnUpdateCommanderPodSubscription
>;
export const onDeleteCommanderPod = /* GraphQL */ `subscription OnDeleteCommanderPod(
  $filter: ModelSubscriptionCommanderPodFilterInput
) {
  onDeleteCommanderPod(filter: $filter) {
    id
    eventId
    roundId
    roundNumber
    podNumber
    category
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCommanderPodSubscriptionVariables,
  APITypes.OnDeleteCommanderPodSubscription
>;
export const onCreateCommanderPodPlayer = /* GraphQL */ `subscription OnCreateCommanderPodPlayer(
  $filter: ModelSubscriptionCommanderPodPlayerFilterInput
) {
  onCreateCommanderPodPlayer(filter: $filter) {
    id
    eventId
    roundId
    podId
    roundNumber
    userId
    playerConstructId
    registeredCategory
    placement
    points
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCommanderPodPlayerSubscriptionVariables,
  APITypes.OnCreateCommanderPodPlayerSubscription
>;
export const onUpdateCommanderPodPlayer = /* GraphQL */ `subscription OnUpdateCommanderPodPlayer(
  $filter: ModelSubscriptionCommanderPodPlayerFilterInput
) {
  onUpdateCommanderPodPlayer(filter: $filter) {
    id
    eventId
    roundId
    podId
    roundNumber
    userId
    playerConstructId
    registeredCategory
    placement
    points
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCommanderPodPlayerSubscriptionVariables,
  APITypes.OnUpdateCommanderPodPlayerSubscription
>;
export const onDeleteCommanderPodPlayer = /* GraphQL */ `subscription OnDeleteCommanderPodPlayer(
  $filter: ModelSubscriptionCommanderPodPlayerFilterInput
) {
  onDeleteCommanderPodPlayer(filter: $filter) {
    id
    eventId
    roundId
    podId
    roundNumber
    userId
    playerConstructId
    registeredCategory
    placement
    points
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCommanderPodPlayerSubscriptionVariables,
  APITypes.OnDeleteCommanderPodPlayerSubscription
>;
export const onCreateEventTopCutResult = /* GraphQL */ `subscription OnCreateEventTopCutResult(
  $filter: ModelSubscriptionEventTopCutResultFilterInput
) {
  onCreateEventTopCutResult(filter: $filter) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    bonusPoints
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEventTopCutResultSubscriptionVariables,
  APITypes.OnCreateEventTopCutResultSubscription
>;
export const onUpdateEventTopCutResult = /* GraphQL */ `subscription OnUpdateEventTopCutResult(
  $filter: ModelSubscriptionEventTopCutResultFilterInput
) {
  onUpdateEventTopCutResult(filter: $filter) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    bonusPoints
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEventTopCutResultSubscriptionVariables,
  APITypes.OnUpdateEventTopCutResultSubscription
>;
export const onDeleteEventTopCutResult = /* GraphQL */ `subscription OnDeleteEventTopCutResult(
  $filter: ModelSubscriptionEventTopCutResultFilterInput
) {
  onDeleteEventTopCutResult(filter: $filter) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    bonusPoints
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEventTopCutResultSubscriptionVariables,
  APITypes.OnDeleteEventTopCutResultSubscription
>;
